var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegGradeUniversal = function SvgRegGradeUniversal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 46.15,
    height: 46.15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.075 0C35.816 0 46.15 10.334 46.15 23.075S35.816 46.15 23.075 46.15 0 35.816 0 23.075 10.334 0 23.075 0Z",
    fill: "#7BB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.075 0v46.15C10.334 46.15 0 35.816 0 23.075S10.334 0 23.075 0Z",
    fill: "#0A1B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.854 31.963a9.359 9.359 0 0 0-.99 3.891C8 42.06 15.058 46.15 23.074 46.15c8.016 0 15.074-4.09 19.212-10.296a9.436 9.436 0 0 0-.996-3.891c-3.11-6.13-11.29-5.115-12.348-6.689-.82-1.223-.332-4.977-.388-5.944-3.83.365-7.096.285-10.926-.08-.053.967.393 4.802-.427 6.024-1.057 1.574-9.239.56-12.348 6.689Z",
    fill: "#E09C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.854 31.963a9.359 9.359 0 0 0-.99 3.891C8 42.06 15.058 46.15 23.074 46.15V19.563c-1.768-.02-3.536-.133-5.442-.313-.052.967.394 4.802-.426 6.024-1.057 1.574-9.239.56-12.348 6.689h-.005Z",
    fill: "#C47A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.527 13.784c-.247-.294-.598-.374-.963-.327.01-.341.015-.682.015-1.019 0-1.962-.005-4.37-.692-5.74-.498-1.005-1.261-1.66-2.157-2.147-3.446-1.863-5.864-1.863-9.31 0-.9.488-1.659 1.142-2.157 2.147-.687 1.374-.692 3.782-.692 5.74 0 .337.005.678.015 1.02-.365-.048-.716.032-.963.326-.568.683-.317 2.162.237 3.214.204.389.446.716.806.962.147.105.303.18.446.214.242 1.114.578 2.161 1.038 3.1.635 1.299 1.502 2.38 2.673 3.095 1.835 1.123 4.683 1.123 6.518 0 1.17-.716 2.038-1.796 2.673-3.095.46-.939.797-1.991 1.038-3.1.147-.034.3-.11.446-.214.36-.246.602-.578.806-.962.555-1.052.801-2.531.232-3.214h-.01Z",
    fill: "#FDC484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.754 3.517c-.9-.877-2.219-1.384-3.887-1.664-.555-.094-3.072-.085-3.65.015-1.636.28-2.925.786-3.816 1.65-2.223 2.156-2.351 6.01-1.986 10.262 1.322-2.65 3.375-3.802 5.84-4.12.588-.075 2.99-.08 3.545-.014 2.508.299 4.603 1.446 5.95 4.134.36-4.252.232-8.106-1.992-10.263h-.004Z",
    fill: "#0F68EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.075 3.147c-1.465 0-2.934.465-4.655 1.394-.9.488-1.659 1.142-2.157 2.147-.687 1.375-.692 3.783-.692 5.74 0 .337.005.678.015 1.02-.365-.048-.716.033-.963.327-.568.682-.317 2.161.237 3.214.204.388.446.715.806.962.147.104.303.18.446.213.242 1.114.578 2.162 1.038 3.1.635 1.3 1.502 2.38 2.673 3.096.915.564 2.086.843 3.261.843V3.143l-.009.004Z",
    fill: "#E09C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.075 1.792c-.777 0-1.569.028-1.863.08-1.635.28-2.924.787-3.816 1.65-2.223 2.157-2.35 6.01-1.986 10.262 1.323-2.65 3.375-3.801 5.84-4.119.299-.038 1.071-.057 1.825-.061V1.792Z",
    fill: "#004AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.823 24.767c-1.166-.678-2.033-1.697-2.668-2.924-.413-.797-.726-2.105-.958-3.034 1.759-1.996 4.195-2.802 6.878-2.802s5.115.806 6.878 2.802c-.232.934-.545 2.237-.958 3.034-.635 1.227-1.497 2.246-2.664 2.924-1.83 1.062-4.673 1.062-6.503 0h-.005Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.823 24.767c-1.166-.678-2.033-1.697-2.668-2.924-.413-.797-.726-2.105-.958-3.034 1.759-1.996 4.195-2.802 6.878-2.802v9.552c-1.166 0-2.337-.266-3.252-.797v.005Z",
    fill: "#DDEAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.854 31.963a9.359 9.359 0 0 0-.99 3.891C8 42.06 15.058 46.15 23.074 46.15c8.016 0 15.074-4.09 19.212-10.296a9.436 9.436 0 0 0-.996-3.891c-2.365-4.66-7.66-5.19-10.527-5.869-.745 2.46-3.788 4.304-7.433 4.304s-6.788-1.905-7.466-4.427c-2.711.754-8.508 1.057-11.011 5.992Z",
    fill: "#E8EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.87 25.966c-2.711.754-8.509 1.057-11.011 5.992a9.36 9.36 0 0 0-.991 3.892c3.948 5.925 10.561 9.916 18.126 10.267-.806-2.645-6.048-19.88-6.12-20.155l-.004.005Z",
    fill: "#6BC7B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.28 25.966c2.711.754 8.509 1.057 11.011 5.992a9.358 9.358 0 0 1 .991 3.892c-3.948 5.925-10.561 9.916-18.126 10.267.8-2.64 6.048-19.88 6.12-20.155l.004.005Z",
    fill: "#3D8EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.854 31.963a9.359 9.359 0 0 0-.99 3.891C8 42.06 15.058 46.15 23.074 46.15V30.394c-3.584-.085-6.541-1.963-7.21-4.423-2.711.754-8.508 1.057-11.011 5.992Z",
    fill: "#D4DDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.87 25.966c-2.711.754-8.509 1.057-11.011 5.992a9.36 9.36 0 0 0-.991 3.892c3.948 5.925 10.561 9.916 18.126 10.267-.806-2.645-6.048-19.88-6.12-20.155l-.004.005Z",
    fill: "#004AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76 41.922c-.175-4.03-.104-4.072-.53-.389.174.133.35.26.53.389Z",
    fill: "#21564F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.39 41.922c.175-4.03.11-4.072.53-.389-.174.133-.35.26-.53.389Z",
    fill: "#2A7269"
  }))));
};
export default SvgRegGradeUniversal;